<template>
  <div
    v-if="!contentFocused"
    class="kk-panel__container"
    :class="{ 'kk-panel__container-invisible': !isSubNavigationVisible }"
  >
    <div
      class="kk-panel"
      :style="{ width: `${panelWidth}px` }"
      :class="{ 'kk-panel-toggle-width': !isSubNavigationVisible }"
    >
      <red-zone-spots />
      <red-zone-content />
    </div>
    <div v-if="isSubNavigationVisible" class="kk-panel__container-resize" @mousedown="$emit('resizing-started')"></div>
  </div>
</template>

<script>
import RedZoneSpots from "./spots/RedZoneSpots.vue";
import RedZoneContent from "./content/RedZoneContent.vue";
export default {
  components: {
    RedZoneSpots,
    RedZoneContent,
  },
  emits: ["resizing-started"],
  computed: {
    isSubNavigationVisible() {
      return this.$store.state.panel.isSubNavigationVisible;
    },
    contentFocused() {
      return this.$store.state.pdesign.contentFocused;
    },
    panelWidth() {
      return this.$store.state.preferences.allPreferences?.panelWidth || 350;
    },
  },
  watch: {
    $route(to, from) {
      to.matched.forEach((route) => {
        if (route.path == "/designs/:id?" && to.params.id) {
          this.load(to.params.id);
        }
      });
    },
  },
  mounted() {
    this.$store.dispatch("players/load");
    this.$store.dispatch("processes/load", { id: this.$route.params.id });
    this.$store.dispatch("grids/load", { id: this.$route.params.id });
    this.$store.dispatch("businesses/load", { id: this.$route.params.id });
    this.$store.dispatch("teams/load");
    this.$store.dispatch("smartSearch/load");
  },
  methods: {
    load(designId) {
      this.$store.dispatch("cells/load", designId);
    },
    mouseDown() {
      this.startResizing = true;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/styles/variables";

.kk-panel {
  display: flex;

  &-toggle-width {
    width: 3.3rem !important;
  }

  &__container {
    padding: @kk-sidebar-wrapper-padding 0 @kk-sidebar-wrapper-padding 0.8rem;
    display: flex;
    position: relative;
    transition: all 0.3s ease-in-out;

    &-invisible {
      padding-left: 0px; /* desired padding */
    }

    &-resize {
      position: absolute;
      right: -4px;
      top: 0;
      width: 5px;
      height: 100%;
      z-index: 51;
      &:hover {
        cursor: col-resize;
      }
    }
  }
}
</style>
